import React, { useContext, useEffect, useState } from "react"
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  label,
  Input,
  Button,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Label,
} from "reactstrap"
import { DataContext } from "../../context/dataContext"
import moment from "moment"
import createIntent from "../../common/config/createIntent"
import apiHandler from "../../common/config/apiHandler"
import ExtendBooking from "../../common/config/extend-boooking"
import toast from "react-hot-toast"
import DatePicker from "react-datepicker"
import StripeElement from "../../components/Stripe/StripeElement"
import domainUrl from "../../common/config/domainUrl"
import { useNavigate } from "react-router-dom"

const AmendDates = ({
  public_key,
  isOpen,
  toggle,
  onSubmit,
  setActiveTab,
  handleFetchBookingDetails,
}) => {
  const { token, bookingDetails, fetchSubscribeKey, subscribeKey } =
    useContext(DataContext)
  const [checkbox, setCheckbox] = useState({
    company_email: true,
    customer_email: true,
  })

  const navigate = useNavigate()

  const handleCheckboxChange = e => {
    const { name, type, value } = e.target
    setCheckbox(prevData => ({
      ...prevData,
      [name]:
        type === "checkbox" ? (prevData[name] === "1" ? "0" : "1") : value,
    }))
  }

  const [amendData, setAmendData] = useState({
    departure_date: "",
    departure_time: "",
    arrival_date: "",
    arrival_time: "",
    company_id: "",
    site_id: "",
    airport: "",
    payment: { amount: 0, admin_charges: 0 },
    company_email: checkbox?.company_email,
    customer_email: checkbox?.customer_email,
  })
  const [quoteData, setQuoteData] = useState({})
  const [loadingQuote, setLoadingQuote] = useState(false)
  const [loadingPayment, setLoadingPayment] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [quoteDifference, setQuoteDifference] = useState(0)
  const [extraCharges, setExtraCharges] = useState(0)
  const [payableAmount, setPayableAmount] = useState(0)
  const [payment_intent, setPayment_Intent] = useState("")
  const [paymentOption, setPaymentOption] = useState("")
  const [apiTag, setApiTag] = useState(null)
  const [transactionID, setTransactionID] = useState("")
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
  })

  const [isPaymentElementMounted, setIsPaymentElementMounted] = useState(false)

  const [clientSecret, setClient_Secret] = useState("")

  // const [subscribeKey, setSubscribeKey] = useState("")

  useEffect(() => {
    if (
      bookingDetails &&
      bookingDetails.bookingDetails &&
      bookingDetails.bookingDetails.length > 0
    ) {
      const detail = bookingDetails?.bookingDetails?.find(
        detail => detail?.is_current === true || detail?.is_current === 1
      )
      if (detail) {
        setAmendData({
          ...detail,
          airport: detail?.airport?.code,
          departure_date: detail?.departure_date || "",
          departure_time: detail?.departure_time || "",
          arrival_date: detail?.arrival_date || "",
          arrival_time: detail?.arrival_time || "",
          company_id: detail?.company?.id || "",
          site_id: bookingDetails.site_id || "",
          payment: detail?.payment || { amount: 0, admin_charges: 0 },
        })

        setExtraCharges(bookingDetails?.site?.extend_charge)
        setApiTag(detail?.company?.sku_tag)
        setFormData({
          firstName: detail?.customer?.first_name,
          lastName: detail?.customer?.last_name,
        })
      }
    }
  }, [bookingDetails])

  useEffect(() => {
    if (paymentOption == "stripe-dashboard") {
      const currentDetail = bookingDetails?.bookingDetails?.find(
        detail => detail?.is_current === true || detail?.is_current === 1
      )

      setTransactionID(currentDetail?.payment?.transaction_id)
    }
  }, [paymentOption])

  useEffect(() => {
    setPayableAmount(
      parseFloat(quoteDifference) +
      parseFloat(extraCharges) -
      parseFloat(amendData.payment?.amount)
    )
  }, [quoteDifference, extraCharges, amendData.payment?.amount])

  useEffect(() => {
    if (bookingDetails) {
      fetchSubscribeKey(apiTag, bookingDetails?.site_id)
    }
  }, [bookingDetails])

  const handleChange = e => {
    const { name, value, type, checked } = e.target
    setAmendData({
      ...amendData,
      [name]: type === "checkbox" ? checked : value,
    })
  }

  const handleCreateIntent = async () => {
    if (!subscribeKey) return

    setLoadingPayment(true)

    try {
      if (subscribeKey) {
        const paymentIntentResponse = await createIntent({
          key: subscribeKey,
          amount: payableAmount.toFixed(2),
          description: bookingDetails?.multi_mode,

        })

        if (paymentIntentResponse?.client_secret) {
          setClient_Secret(paymentIntentResponse?.client_secret)
          setPayment_Intent(paymentIntentResponse?.payment_intent)
        } else {
          setClient_Secret("")
          setPayment_Intent("")
          alert("Failed to create payment intent. Please try again.")
        }
      }
    } catch (error) {
      console.error("Payment error:", error)
      alert(
        "Error creating payment intent. Please try again. Error: " +
        error.message
      )
    } finally {
      setLoadingPayment(false)
    }
  }

  const handleGetQuote = async () => {
    const {
      departure_date,
      departure_time,
      arrival_date,
      arrival_time,
      site_id,
      airport,
      company_id,
    } = amendData

    if (!departure_date || !departure_time || !arrival_date || !arrival_time) {
      alert("Please fill in all date and time fields before getting a quote.")
      return
    }

    setLoadingQuote(true)
    try {
      const params = new URLSearchParams({
        site_id,
        airport,
        departure: moment(
          `${amendData.departure_date} ${amendData.departure_time}`
        ).format("DD-MM-YYYY HH:mm"),
        arrival: moment(
          `${amendData.arrival_date} ${amendData.arrival_time}`
        ).format("DD-MM-YYYY HH:mm"),
        company_id,
      })

      const response = await apiHandler({
        endpoint2: `/extendProduct?${params.toString()}`,
        method: "GET",
      })

      if (response?.response_code === 200) {
        setQuoteData(response?.data)
        setQuoteDifference(response?.data?.price || 0)
      } else {
        alert(
          response?.message || "Failed to fetch quote. Please try again later."
        )
      }
    } catch (error) {
      console.error("Error fetching quote:", error)
      alert("Network error occurred while fetching the quote.")
    } finally {
      setLoadingQuote(false)
    }
  }

  const handleSubmit = async transaction_id => {
    try {
      const user = JSON.parse(localStorage.getItem("user"))

      setLoadingPayment(true)

      const extendResponse = await ExtendBooking({
        key: subscribeKey,
        user_id: String(user?.id),
        site_id: amendData?.site_id,
        reference_no: bookingDetails?.reference_no,
        company_id: amendData?.company?.id,
        departure: moment(
          `${amendData.departure_date} ${amendData.departure_time}`
        ).format("DD-MM-YYYY HH:mm"),
        arrival: moment(
          `${amendData.arrival_date} ${amendData.arrival_time}`
        ).format("DD-MM-YYYY HH:mm"),
        amount: quoteData.price,
        extar_amount: extraCharges,
        payment_type: paymentOption,
        transaction_id: transaction_id ? transaction_id : transactionID,
        payment_intent_id: transaction_id ? transaction_id : transactionID,
        customer_email: checkbox?.company_email ? "1" : "0",
        company_email: checkbox?.customer_email ? "1" : "0",
      })

      if (extendResponse?.response_code == 200) {
        handleFetchBookingDetails(bookingDetails?.id)
        toast.success(extendResponse?.data)
        setLoadingPayment(false)
        setActiveTab("")
        navigate("/allBookings")
        setTimeout(() => {
          window.location.reload()
        }, 100)
      } else {
        setLoadingPayment(false)
        setSubmitLoading(false)
      }
    } catch (error) {
      setLoadingPayment(false)
      setSubmitLoading(false)
      toast.error(error?.errors || "An error occurred. Please try again.")
    }
  }

  const handleWorldPay = async () => {
    const user = JSON.parse(localStorage.getItem("user"))
    setLoadingPayment(true)

    try {
      const response = await apiHandler({
        endpoint: "/backend/payment/create-worldpay-session",
        method: "POST",
        options: {
          "x-access-token": localStorage.getItem("token"),
        },
        data: {
          type: "amendBooking",
          key: subscribeKey,
          extra_amount: extraCharges || 0,
          site_id: amendData?.site_id,
          company_id: amendData?.company?.id,
          amount: payableAmount,
          departure: moment(
            `${amendData.departure_date} ${amendData.departure_time}`
          ).format("DD-MM-YYYY HH:mm"),
          arrival: moment(
            `${amendData.arrival_date} ${amendData.arrival_time}`
          ).format("DD-MM-YYYY HH:mm"),
          multi_mode_reference_no: bookingDetails?.multi_mode,
          reference_no: bookingDetails?.reference_no,
          payment_type: paymentOption,
          user_id: String(user?.id),
          customer_email: checkbox?.company_email ? "1" : "0",
          company_email: checkbox?.customer_email ? "1" : "0",
          notify: `${domainUrl}/worldpay-notify?multi_mode_reference_no=${bookingDetails?.multi_mode}&reference_no=${bookingDetails?.reference_no}`,
          response: `${domainUrl}/worldpay-response?multi_mode_reference_no=${bookingDetails?.multi_mode}&reference_no=${bookingDetails?.reference_no}`,
          cancel: `${domainUrl}/worldpay-cancel?multi_mode_reference_no=${bookingDetails?.multi_mode}&reference_no=${bookingDetails?.reference_no}`,
        },
      })

      if (response) {
        if (typeof window !== "undefined") {
          setLoadingPayment(false)
          window.location.href = response?.data?.redirectUrl
          // console.log("host--------------", domainUrl);
        }
      }
    } catch (error) {
      setLoadingPayment(false)
      toast.error(error.response?.data?.message, { duration: 3000 })
    }
  }

  console.log(bookingDetails, "bookingDetails")


  return (
    <Card>
      {/* <CardBody> */}

      <ModalBody style={{ overflowY: "visible" }}>
        <div>
          <h6 style={{ fontWeight: "600" }}> Amend Dates</h6>
        </div>
        <form>
          <Row>
            <Col md={6}>
              <FormGroup>
                <label for="departureDate" style={{ fontSize: "11px" }}>
                  Departure Date*
                </label>
                <DatePicker
                  selected={
                    amendData.departure_date
                      ? new Date(amendData.departure_date)
                      : null
                  }
                  onChange={date =>
                    handleChange({
                      target: {
                        name: "departure_date",
                        value: moment(date).format("YYYY-MM-DD"),
                      },
                    })
                  }
                  minDate={new Date()}
                  className="form-input f-11"
                  dateFormat="dd-MMM-yyyy"
                  required
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <label for="departureTime" style={{ fontSize: "11px" }}>
                  Departure Time*
                </label>
                <DatePicker
                  selected={
                    amendData?.departure_time
                      ? new Date(`1970-01-01T${amendData?.departure_time}`)
                      : null
                  }
                  onChange={time =>
                    handleChange({
                      target: {
                        name: "departure_time",
                        value: time.toTimeString().slice(0, 5),
                      },
                    })
                  }
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeFormat="HH:mm"
                  dateFormat="HH:mm"
                  className="form-input f-11"
                  required
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <FormGroup>
                <label for="arrivalDate" style={{ fontSize: "11px" }}>
                  Arrival Date*
                </label>
                <DatePicker
                  selected={
                    amendData.arrival_date
                      ? new Date(amendData.arrival_date)
                      : null
                  }
                  onChange={date =>
                    handleChange({
                      target: {
                        name: "arrival_date",
                        value: moment(date).format("YYYY-MM-DD"),
                      },
                    })
                  }
                  minDate={new Date()}
                  className="form-input f-11"
                  dateFormat="dd-MMM-yyyy"
                  required
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <label for="arrivalTime" style={{ fontSize: "11px" }}>
                  Arrival Time*
                </label>
                <DatePicker
                  selected={
                    amendData?.arrival_time
                      ? new Date(`1970-01-01T${amendData?.arrival_time}`)
                      : null
                  }
                  onChange={time =>
                    handleChange({
                      target: {
                        name: "arrival_time",
                        value: time.toTimeString().slice(0, 5),
                      },
                    })
                  }
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeFormat="HH:mm"
                  dateFormat="HH:mm"
                  className="form-input f-11"
                  required
                />
              </FormGroup>
            </Col>
          </Row>

          <Button
            color="warning"
            size="sm"
            className="mb-3"
            onClick={handleGetQuote}
            disabled={loadingQuote}
            style={{ width: "100px" }}
          >
            {loadingQuote ? <Spinner size="sm" /> : "Get Quote"}
          </Button>

          {quoteData?.price && (
            <>
              <h5>Quote Details</h5>
              {Number(quoteData.price) > Number(amendData?.payment?.amount) ? (
                <div className="alert alert-success" role="alert">
                  New Quote Amount {Number(quoteData.price).toFixed(2)} is
                  greater than Quoted Amount{" "}
                  {Number(amendData?.payment?.amount).toFixed(2)}. Customer
                  already paid{" "}
                  {(
                    (parseFloat(amendData?.payment.amount) || 0) +
                    (parseFloat(amendData?.payment.cancellation_charges) || 0) +
                    (parseFloat(amendData?.payment.sms_charges) || 0) +
                    (parseFloat(amendData?.payment.levy_charges) || 0) +
                    (parseFloat(amendData?.payment.valet_charges) || 0) +
                    (parseFloat(amendData?.payment.admin_charges) || 0) +
                    (parseFloat(amendData?.payment.extra_charges) || 0) -
                    (parseFloat(amendData?.payment.discount) || 0)
                  ).toFixed(2)}
                  <br />
                </div>
              ) : (
                <div className="alert alert-warning" role="alert">
                  New Quote Amount {Number(quoteData.price).toFixed(2)} is less
                  than or equal to Quoted Amount{" "}
                  {Number(amendData?.payment?.amount).toFixed(2)}. <br />
                  Customer already paid{" "}
                  {(
                    (parseFloat(amendData?.payment.amount) || 0) +
                    (parseFloat(amendData?.payment.cancellation_charges) || 0) +
                    (parseFloat(amendData?.payment.sms_charges) || 0) +
                    (parseFloat(amendData?.payment.levy_charges) || 0) +
                    (parseFloat(amendData?.payment.valet_charges) || 0) +
                    (parseFloat(amendData?.payment.admin_charges) || 0) +
                    (parseFloat(amendData?.payment.extra_charges) || 0) -
                    (parseFloat(amendData?.payment.discount) || 0)
                  ).toFixed(2)}
                </div>
              )}

              <div className="d-flex justify-content-between">
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label htmlFor="quoteDifference">
                        Quote Difference *
                      </label>
                      <Input
                        type="number"
                        name="quoteDifference"
                        id="quoteDifference"
                        value={(
                          Number(quoteDifference) -
                          Number(amendData?.payment?.amount || 0)
                        ).toFixed(2)}
                        onChange={e =>
                          setQuoteDifference(Number(e.target.value))
                        }
                        className="border-secondary"
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                  {/* <Col md={6}>
                    <FormGroup>
                      <label for="extraCharges">Extra Charges*</label>
                      <Input
                        type="number"
                        name="extraCharges"
                        id="extraCharges"
                        value={Number(extraCharges).toFixed(2)}
                        onChange={e => setExtraCharges(Number(e.target.value))}
                        className="border-secondary"
                      />
                    </FormGroup>
                  </Col> */}
                  <Col md={6}>
                    <FormGroup>
                      <label for="extraCharges">Extra Charges*</label>
                      <Input
                        type="text"
                        name="extraCharges"
                        id="extraCharges"
                        value={extraCharges}
                        onChange={e => {
                          const value = e.target.value
                          if (/^\d*\.?\d*$/.test(value) || value === "") {
                            setExtraCharges(value)
                          }
                        }}
                        className="border-secondary"
                        placeholder="Enter extra charges"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              <div className="d-flex justify-content-between">
                <Col md={12}>
                  <FormGroup>
                    <label for="payableAmount">Payable Amount*</label>
                    <Input
                      type="number"
                      name="payableAmount"
                      id="payableAmount"
                      value={Number(payableAmount).toFixed(2)}
                      className="border-secondary"
                      disabled
                    />
                  </FormGroup>
                </Col>
              </div>
              <StripeElement
                public_key={public_key}
                paymentOption={paymentOption}
                setPaymentOption={setPaymentOption}
                payment_intent={payment_intent}
                clientSecret={clientSecret}
                handleCreateIntent={handleCreateIntent}
                transactionID={transactionID}
                setTransactionID={setTransactionID}
                setLoadingPayment={setLoadingPayment}
                submitLoading={submitLoading}
                extraCharges={payableAmount}
                setSubmitLoading={setSubmitLoading}
                handleComplete={handleSubmit}
                apiTag={apiTag}
                formData={formData}
              />
              <Row>
                <Col md={6}>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        className="border-primary"
                        name="customer_email"
                        checked={checkbox?.customer_email == "1" ? true : false}
                        onClick={handleCheckboxChange}
                        style={{ fontSize: "11px" }}
                      />{" "}
                      Send Customer Email
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        className="border-primary"
                        name="company_email"
                        checked={checkbox?.company_email == "1" ? true : false}
                        onClick={handleCheckboxChange}
                        style={{ fontSize: "11px" }}
                      />{" "}
                      Send Company Email
                    </Label>
                  </FormGroup>
                </Col>
              </Row>

              <Button
                type="button"
                color="primary"
                // disabled={
                //   !clientSecret ||
                //   !paymentOption ||
                //   (paymentOption == "worldpay" && false)
                // }
                size="sm"
                className="me-3 mt-2"
                style={{ width: "80px" }}
                onClick={() => {
                  if (paymentOption == "worldpay") {
                    handleWorldPay()
                  } else {
                    if (paymentOption == "") {
                      toast.error("Please select a payment option", {
                        duration: 3000,
                      })
                      return
                    } else {
                      setSubmitLoading(true)
                    }
                  }
                }}
                disabled={loadingPayment}
              >
                {submitLoading || loadingPayment ? <Spinner size="sm" /> : "Submit"}
              </Button>
              <Button
                color="danger"
                onClick={() => setActiveTab("")}
                size="sm"
                className="mt-2"
              >
                Cancel
              </Button>
            </>
          )}
        </form>
      </ModalBody>
      {/* </CardBody> */}
    </Card>
  )
}

export default AmendDates
